/**
 * Game End Screen — Final scores, round breakdown, winner.
 */

import { getState, resetGame } from '../game-state';
import { navigate } from '../router';
import { t } from '../i18n';

export function renderGameEnd(): void {
  const app = document.getElementById('app')!;
  const state = getState();
  const { scores, roundScores, settings } = state;

  // Determine winner
  let winnerText: string;
  if (scores.A > scores.B) {
    winnerText = t('teamAWins');
  } else if (scores.B > scores.A) {
    winnerText = t('teamBWins');
  } else {
    winnerText = t('itsATie');
  }

  // Build round breakdown rows
  const roundRows = Array.from(
    { length: settings.rounds },
    (_, i) => i + 1
  ).map((r) => {
    const rs = roundScores[r] || { A: 0, B: 0 };
    return `<tr>
      <td>${t('round')} ${r}</td>
      <td>${rs.A}</td>
      <td>${rs.B}</td>
    </tr>`;
  }).join('');

  app.innerHTML = `
    <div class="stack center">
      <h1>${t('gameOver')}</h1>
      <div class="winner-display">${winnerText}</div>

      <div class="final-scores">
        <div class="final-score-team">
          <div class="score-label">${t('teamA')}</div>
          <div class="score-value">${scores.A}</div>
        </div>
        <div class="final-score-team">
          <div class="score-label">${t('teamB')}</div>
          <div class="score-value">${scores.B}</div>
        </div>
      </div>

      <table class="round-breakdown surface">
        <thead>
          <tr><th>${t('round')}</th><th>${t('teamA')}</th><th>${t('teamB')}</th></tr>
        </thead>
        <tbody>${roundRows}</tbody>
      </table>

      <button class="btn btn-primary" id="btn-play-again">${t('playAgain')}</button>
      <button class="btn btn-tertiary" id="btn-menu">${t('mainMenu')}</button>
    </div>
  `;

  document.getElementById('btn-play-again')?.addEventListener('click', () => {
    resetGame();
    navigate('lobby');
  });

  document.getElementById('btn-menu')?.addEventListener('click', () => {
    resetGame();
    navigate('menu');
  });
}
